/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-11-15 13:46:42
 * @LastEditors: linxi
 * @LastEditTime: 2024-03-06 18:40:32
 */
import { unwrapResult } from '@reduxjs/toolkit'
import { Button, Col, Space, Tabs } from 'antd'
import React, { ReactElement, useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { RootDispatch } from '../../app/store'
import { TabBar, TabPane } from '../../compnents/widgets/TabBar'
import { RecipeStatus } from '../../models/recipe'
import styles from './functionSettingTabs.module.css'
import { useSelector } from 'react-redux'
import { FunctionSettingPage } from './functionSettingPage/functionSettingPage'

export const FunctionSettingTabs = (): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const location: any = useLocation()

  const [selectedTab, setSelectedTab] = useState<any>('1')

  return (
    <Col className={styles.container}>
      <TabBar
        defaultActiveKey={
          location?.state ? location?.state?.selectedTab : selectedTab || '1'
        }
        onChange={(v) => {
          setSelectedTab(v)
        }}
      >
        <TabPane key='1' tab='功能设置'>
          <FunctionSettingPage selectedTab={selectedTab} />
        </TabPane>
        {/* <TabPane key='2' tab='数据权限设置'></TabPane>
        <TabPane key='3' tab='打印设置'></TabPane>
        <TabPane key='4' tab='自定义打印设置'></TabPane> */}
      </TabBar>
    </Col>
  )
}
